import React from 'react';
import Button from "../../../libs/uiKit/button";
import DropdownMenu from "../../../libs/uiKit/dropdownMenu";
import {StyledDashboardButtons} from "./ui/styles";
import {useGlobalContext} from "../../../apps/main/ui/GlobalContext";
import {useNavigate} from "react-router-dom";
import {IDropdownItem} from "../../../libs/uiKit/dropdownMenu/types";
import SkipPrecalculationIgniter from "../../widgets/skipPrecalculation";
import CrossModal from "../invoice/widgets/CrossModal";

const NewAgreementButtons = () => {

    const {
        routes: { flat, precalculation, createAgreementStep },
        user: { crossEnabled, flatEnabled, banksOk }
    } = useGlobalContext();

    const navigate = useNavigate();



    const [stateSkipPrecalculationModal, setSkipPrecalculationModal] = React.useState<boolean>(false);
    const [stateCrossModal, setStateCrossModal] = React.useState<boolean>(false);

    const dropDownItems: IDropdownItem[] = React.useMemo(
        () => [
            {
                label: 'С предварительным расчетом',
                onClick: () => navigate(precalculation()),
            },
            {
                label: 'Без предварительного расчета',
                onClick: () => setSkipPrecalculationModal(true),
            },
        ],
        [navigate, precalculation]
    );

    return <>
        <StyledDashboardButtons>
            {(crossEnabled || flatEnabled) && banksOk && <>
                <DropdownMenu
                    trigger={
                        <Button appearance='filled'>
                            Добровольное страхование
                        </Button>
                    }
                    items={[
                        ...(flatEnabled ? [
                            {
                                label: 'Квартира с тарификацией',
                                onClick: () => navigate(flat()),
                            },
                        ]: []),
                        ...(crossEnabled ? [
                            {
                                label: 'Защита ипотеки',
                                onClick: () => setStateCrossModal(true),
                            },
                        ]: []),
                    ]}
                />
                &nbsp;&nbsp;&nbsp;
                </>
            }
            {banksOk && <Button appearance="filled" onClick={() => navigate(precalculation())}>
                Ипотечное страхование
            </Button>}
        </StyledDashboardButtons>
        <SkipPrecalculationIgniter
            isOpen={stateSkipPrecalculationModal}
            onClose={() => setSkipPrecalculationModal(false)}
            skipCallback={(id) => navigate(createAgreementStep(id, 'contragentStep'))}
        />
        <CrossModal
            onClose={() => setStateCrossModal(false)}
            isOpen={stateCrossModal}
            data={{
                dateBegin: null,
                searchMode: true
            }}
        />
    </>;
}

export default NewAgreementButtons;